import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { IAffiliateUser } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'affiliate';

/** Affiliate reporting (admin-only). Moved from the app's services/affiliate.service.ts. */
@Injectable({ providedIn: 'root' })
export class AdminAffiliateApiService {
  private readonly http = inject(HttpClient);

  list(): Observable<IAffiliateUser[]> {
    return this.http.get<IAffiliateUser[]>(API_URL);
  }

  /** The affiliate's own row first, then the hosts they referred. */
  forUser(userId: number): Observable<IAffiliateUser[]> {
    return this.http.get<IAffiliateUser[]>(`${API_URL}/${userId}`);
  }
}
